module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ab23a6df65da9d1bfdb825aa9307686.gif";